import { Navigate, Route } from 'react-router-dom-v5-compat';

import useIsITEInternal from 'dashboard/apps/InquiryTemplateEditor/hooks/useIsITEInternal';
import { InquiryInspect } from 'dashboard/apps/InquiryTemplateEditor/InquiryInspect/InquiryInspect';
import { SentryRoutes } from 'dashboard/components/SentryRoute/SentryRoute';
import { Inquiry } from 'dashboard/models/inquiry';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import {
  InquiryTemplateVersion,
  InquiryTemplateVersionSchema,
} from 'dashboard/models/inquiry-template-version';
import { WorkflowSchema } from 'dashboard/models/workflow-schema';
import { useExpandCollapseNavbar } from 'lib/hooks/useExpandCollapseNavbar';
import useFeatureFlag from 'lib/hooks/useFeatureFlag';
import { StepPreview } from 'lib/interfaces/StepsConfig';

interface DashboardInquiryInspectShowViewProps {
  inquiry: Inquiry | null;
  inquiryTemplateVersion: InquiryTemplateVersion | null;
  inquiryTemplateVersionSchema: InquiryTemplateVersionSchema | null;
  inquiryTemplateVersionStepsPreview: StepPreview[] | null;
  inquiryTemplate: InquiryTemplate | null;
  referenceId?: string;
  workflowSchema: WorkflowSchema;
  handleCreateInquiry: (props: {
    referenceId?: string;
    accountTypeId?: string;
    fields?: Record<string, any>;
  }) => Promise<void>;
  loadingInquiry: boolean;
  loadingInquiryTemplateData: boolean;
}

const DashboardInquiryInspectShowView = ({
  inquiry,
  inquiryTemplateVersion,
  inquiryTemplateVersionSchema,
  inquiryTemplateVersionStepsPreview,
  inquiryTemplate,
  referenceId,
  workflowSchema,
  handleCreateInquiry,
  loadingInquiry,
  loadingInquiryTemplateData,
}: DashboardInquiryInspectShowViewProps) => {
  const isInquiryInspectEnabled = useFeatureFlag('dashboard:fle-inquiry-inspect');
  const isInternal = useIsITEInternal();

  // collapse dashboard navbar when opening editor for maximum
  // screen real estate. expand when exiting for better UX
  useExpandCollapseNavbar();

  return (
    <SentryRoutes>
      <Route
        index
        element={
          isInquiryInspectEnabled && isInternal ? (
            <InquiryInspect
              inquiryTemplateVersion={inquiryTemplateVersion}
              inquiryTemplateVersionSchema={inquiryTemplateVersionSchema}
              inquiryTemplateVersionStepsPreview={inquiryTemplateVersionStepsPreview}
              inquiryTemplate={inquiryTemplate}
              inquiry={inquiry}
              referenceId={referenceId}
              workflowSchema={workflowSchema}
              isLoadingInquiry={loadingInquiry}
              loadingInquiryTemplateData={loadingInquiryTemplateData}
              handleCreateInquiry={handleCreateInquiry}
            />
          ) : (
            <Navigate to='/dashboard/inquiry-templates' replace />
          )
        }
      />
      <Route path='*' element={<Navigate to='/dashboard/inquiry-templates' replace />} />
    </SentryRoutes>
  );
};

export default DashboardInquiryInspectShowView;
